<h1>Protected</h1>
<p>This route is protected and can only be seen by the following roles:</p>
<p *ngFor="let requiredRole of requiredRoles | async">{{ requiredRole }}</p>
